/**
 * Labstep
 */

import { MetadataManagerContainer as MetadataManager } from 'labstep-web/components/Metadata/Manager';
import { ICONS } from 'labstep-web/constants/icons';
import colDefEntityLink from 'labstep-web/grid/Index/coldefs/Resource/entityLink';
import { Resource } from 'labstep-web/models/resource.model';
import type { ResourceItem } from 'labstep-web/models/resource-item.model';
import { objectOrFunction } from 'labstep-web/services/react.service';

const colDefResourceItemResourceEntityLinkNoLink =
  colDefEntityLink<ResourceItem>({
    getNestedEntity: (params) => params.data?.resource,
    getEntityPreviewProps: (resource) => ({
      secondaryInfo: (
        <MetadataManager entity={resource as Resource} />
      ),
    }),
    noLink: true,
  });

export const colDefResourceItemResourceNoLink = {
  ...colDefResourceItemResourceEntityLinkNoLink,
  colId: 'resource_name',
  headerComponentParams: (params) => ({
    ...objectOrFunction(
      colDefResourceItemResourceEntityLinkNoLink.headerComponentParams,
      params,
    ),
    icon: ICONS.resource.primary,
  }),
  headerName: Resource.getHumanReadableEntityName(false, true),
};
